const API_BASE_ADDRESS = 'http://localhost:4000';

export default class Api {
    static getBinData() {
        const uri = API_BASE_ADDRESS + "/binData";

        return fetch(uri, {
            method: 'GET'
        });
    }
}